/**
 * Thin Billing Module controller. Forwards UI calls to the service unchanged.
 *
 * Per the project's hexagonal rules: controllers are thin; all business logic
 * lives in the service. Add UI-only transformations (sorting, pagination,
 * etc.) here only if they're page-specific and shouldn't pollute the service.
 *
 * Type lives in `src/hexagon/adapters/types/billingModuleController.d.ts`.
 */

export const BillingModuleControllerFactory = ({
  billingModuleService,
}: {
  billingModuleService: IBillingModuleService;
}): IBillingModuleController => ({
  getBillingMonthly: billingModuleService.getBillingMonthly,
  getBillingPatientMonthly: billingModuleService.getBillingPatientMonthly,
  getSignOffAssessment: billingModuleService.getSignOffAssessment,
  updateBillingStatus: billingModuleService.updateBillingStatus,
  bulkUpdateBillingStatus: billingModuleService.bulkUpdateBillingStatus,
  updateSignOffAssessment: billingModuleService.updateSignOffAssessment,
  getBillingChargesByPatientMonth:
    billingModuleService.getBillingChargesByPatientMonth,
  signOffBillingMonth: billingModuleService.signOffBillingMonth,
  markBillingAsBilled: billingModuleService.markBillingAsBilled,
  createCarePlan: billingModuleService.createCarePlan,
  updateCarePlan: billingModuleService.updateCarePlan,
});
